import { Chakra } from "@airhelp/react-ui-components";
import type { RowProps } from "./Row.d";

const { Td, Tr, Text } = Chakra;

const Row = ({ content, isLast }: RowProps) => (
  <Tr {...content.getRowProps()}>
    {content.cells.map((cell, idx) => (
      <Td
        {...cell.getCellProps()}
        pl={4}
        _first={{ border: "none", p: 0, textAlign: "center" }}
        border={isLast && "none"}
        // eslint-disable-next-line react/no-array-index-key
        key={cell.value + cell.row.id + idx}
      >
        <Text as="span" fontSize="sm">
          {cell.render("Cell")}
        </Text>
      </Td>
    ))}
  </Tr>
);

export default Row;
